import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=3af58202&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"
import style1 from "./FileView.vue?vue&type=style&index=1&id=3af58202&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af58202",
  null
  
)

export default component.exports